import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import AdjustmentsSelectiveCopy from '@app/application/adjustments/components/adjustments-selective-copy.vue'

// NOTE these components actually use the html that is part of the server-side
// rendered page, they do not replace the content of the element.
onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='adjustments-selective-copy']").each(function () {
    const $this = $(this)

    createApp(AdjustmentsSelectiveCopy, {
      currentLedgerPeriodName: $this.data('current-ledger-period-name'),
      formAction: $this.data('form-action'),
      tags: $this.data('tags'),
      categories: $this.data('categories'),
      copyTypes: $this.data('copy-types'),
      ledgers: $this.data('ledgers'),
      copyType: $this.data('copy-type'),
      forwardAccounts: $this.data('forward-accounts'),
      totalReplacedHtml: $this.data('totals-html'),
    }).mount(this)
  })
})
